import { Observable } from '@reactivex/rxjs'
import { switchSelected$ } from './intents'
import { update$ } from './firebase-init'

import store$ from './store'

const interval = 30000

export const selected$ = Observable.defer(() =>
  switchSelected$
    .merge(Observable.interval(interval), update$)
    .throttleTime(500)
    .scan(acc => ++acc, -1)
    .withLatestFrom(store$)
    .map(([i, snaphost]) => state => {
      const samples = state.get('samples')
      return state.set('selected', samples.get(i % samples.size))
    })
)



// WEBPACK FOOTER //
// ./selected-sample.js